<template>
    <TableProjectManagement></TableProjectManagement>
</template>

<script>
import { defineAsyncComponent } from "vue";

const TableProjectManagement = defineAsyncComponent(() =>
    import(
        "../../components/ProjectManagement/ProjectProgress/TableProjectManagement.vue"
    )
);
//import TableProjectManagement from "../../components/ProjectManagement/ProjectProgress/TableProjectManagement.vue";
//import AuthLayout from "../../Layouts/AuthLayout.vue";
const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);

export default {
    name: "Project_Management",
    components: { TableProjectManagement, AuthLayout },
};
</script>
